module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Hagerty Quebec","short_name":"Hagerty Quebec","start_url":"/","background_color":"#ffffff","theme_color":"#007bb3","display":"minimal-ui","icon":"src/icons/app-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"5c102305355d0b710eb351924cc8cfaf"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
